// 我的账户
<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block my-account">
      <div class="top-title">我的账户</div>
      <el-form inline size="small">
        <el-row>
          <!-- <el-form-item label="来款账号">
            <el-input placeholder="输入来款账号" clearable  v-model="search.incomingAccount" ></el-input>
          </el-form-item> -->
          <el-form-item label="收款账号">
            <el-input placeholder="输入收款账号" clearable v-model="search.beneficiaryAccount"></el-input>
          </el-form-item>
          <el-form-item label="交易时间">
            <el-date-picker v-model="selectDate" type="datetimerange" clearable size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="类型">
            <el-select v-model="search.feeCode" clearable>
              <el-option v-for="(item, key) in optionType" :key="key" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用途">
            <el-select v-model="search.feeUse" clearable>
              <el-option v-for="(item, key) in optionUse" :key="key" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资金流向">
            <el-select v-model="search.flow" clearable>
              <el-option v-for="(item, key) in optionMoneyFlows" :key="key" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="changeQuery">查询</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="table">
        <div class="tableTitle">
          <div class="text">
            合计支出：
            <span>{{expenditureTotal}}元</span>
          </div>
          <div class="text">
            合计收入：
            <span>{{incomeTotal}}元</span>
          </div>
        </div>
        <el-table class="account-table" v-loading="loading" :data="tableData" border :header-cell-style="{
          textAlign: 'center', background: '#FAFAFA',  color: '#3F434B' }" :cell-style="{ textAlign: 'center' }">
          <el-table-column label="交易时间" width="160px">
            <template slot-scope="scope">{{scope.row.createdTime | datetimeFormat}}</template>
          </el-table-column>
          <el-table-column prop="feeName" label="类型" width="80px"></el-table-column>
          <el-table-column label="用途" width="100px">
            <template slot-scope="scope">{{ optionUse.filter(item=>item.value==scope.row.feeUse)[0].label || ""}}</template>
          </el-table-column>
          <el-table-column prop="amount" label="交易金额(元)"></el-table-column>
          <!-- <el-table-column prop="incomingAccountName" label="来款账号名"></el-table-column>
          <el-table-column prop="incomingAccount" label="来款账号"></el-table-column> -->
          <el-table-column prop="beneficiaryAccountName" label="收款账号名"></el-table-column>
          <el-table-column label="收款账号">
            <template slot-scope="scope">{{formBankNumber(scope.row.beneficiaryAccount)}}</template>
          </el-table-column>
          <el-table-column prop="status" label="交易状态" width="80px">
            <template slot-scope="scope">{{scope.row.status == 0?  '未完成' :  scope.row.status == 1 ? '交易成功' :scope.row.status == 2?  '交易失败' :''}}</template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: center;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="search.pageNumber" :page-size="search.pageSize" layout="total, prev, pager, next,jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import ChooseSearch from '@/components/ChooseSearch/index.vue';
import HeaderImg from '@/components/HeaderImg';
export default {
  components: {
    ChooseSearch,
    HeaderImg
  },
  data() {
    return {
      headerList: [{ name: '首页', path: '/Home' }, { name: '我的账户' }],
      loading: false,
      selectDate: [],
      optionType: [
        {
          value: '保证金',
          label: '保证金'
        },
        {
          value: '成交款',
          label: '成交款'
        },
        {
          value: '清算',
          label: '清算'
        },
        {
          value: '交易服务费',
          label: '交易服务费'
        }
      ],
      optionUse: [
        {
          label: '保证金支付',
          value: '7'
        },
        {
          label: '保证金退款',
          value: '8'
        },
        {
          label: '成交款支付',
          value: '3'
        },
        {
          label: '清算费用',
          value: '9'
        },
        {
          label: '交易服务费',
          value: '10'
        }
      ],
      optionMoneyFlows: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '收入'
        },
        {
          value: '2',
          label: '支出'
        }
      ],
      tableData: [],
      search: {
        userId: this.$store.state.userInfo.id,
        pageNumber: 1,
        pageSize: 10,
        incomingAccount: '', // 来款账号
        beneficiaryAccount: '', // 收款账号
        feeCode: '', // 类型（investment：投资缴费）
        feeUse: '', // 1：会员费支付 2：会员费退款 3：成交款支付 4：成交款退款 5：挂牌服务费支付 6：挂牌服务费退款
        flow: '', // 流向（1：收入 2：支出）,
        pidType: 2
      },
      total: 0,
      expenditureTotal: 0,
      incomeTotal: 0
    };
  },
  methods: {
      // 显示前4后4位银行卡号
    formBankNumber(bankNumber) {
      if (!bankNumber) return
      return `${bankNumber.substr(0, 4)}**********${bankNumber.substr(-4)}`
    },
    //查询
    changeQuery(query) {
      if (this.selectDate && this.selectDate.length > 1) {
        this.search.startTime = this.selectDate[0];
        this.search.endTime = this.selectDate[1];
      } else {
        this.search.startTime = null;
        this.search.endTime = null;
      }
      this.search.pageNumber = 1;
      this.getTransactionList();
    },
    getTransactionList() {
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.search));
      Object.keys(data).forEach(function(key) {
        if (data[key] === '') {
          delete data[key];
        }
      });
      this.$api.my
        .getTransactionList(data)
        .then(response => {
          if (response.code == 1000) {
            this.tableData = response.data;
            this.total = response.total;
            this.expenditureTotal = response.expenditureTotal;
            this.incomeTotal = response.incomeTotal;
          } else {
            this.$message.error(response.message);
          }
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.getTransactionList();
    }
  },
  mounted() {
    this.getTransactionList();
  }
};
</script>
<style lang="scss" scoped>
.my-account {
  /deep/ .el-form-item {
    margin-right: 18px;
  }
  .tableTitle {
    overflow: hidden;
    color: #394259;
    margin-top: 25px;
    margin-bottom: 10px;
    .text {
      float: right;
      margin: 0 10px;
      span {
        color: #22C686;
      }
    }
  }
}
</style>
